import React from "react";

const MARKETPLACE_STEPS = [
    { key: "requested",    label: "Requested" },
    { key: "invoice_sent", label: "Invoiced" },
    { key: "paid",         label: "Paid" },
    { key: "shipped",      label: "Shipped" },
    { key: "received",     label: "Received" },
    { key: "completed",    label: "Complete" },
];

const LOCATION_STEPS = [
    { key: "requested", label: "Requested" },
    { key: "approved",  label: "Approved" },
    { key: "completed", label: "Done" },
];

const MARKETPLACE_ORDER = ["requested", "invoice_sent", "paid", "shipped", "received", "completed"];
const LOCATION_ORDER = ["requested", "approved", "completed"];

function getStepIndex(status, orderType) {
    let normalized = status;
    if (status === "fulfilled") {
        normalized = "completed";
    } else if (status === "handoff_partially_confirmed") {
        normalized = "paid";
    }
    const order = orderType === "location" ? LOCATION_ORDER : MARKETPLACE_ORDER;
    const idx = order.indexOf(normalized);
    return idx === -1 ? 0 : idx; 
}

const OrderProgressBar = ({ status, orderType }) => {
    const steps = orderType === "location" ? LOCATION_STEPS : MARKETPLACE_STEPS;
    const currentIndex = getStepIndex(status, orderType);
    const isCancelled = status === "denied" || status === "cancelled";

    return (
        <div className="orders-progress">
            {steps.map((step, i) => {
                let stepClass = "orders-progress__step";
                if (isCancelled) {
                    stepClass += " orders-progress__step--cancelled";
                } else if (i < currentIndex) {
                    stepClass += " orders-progress__step--completed";
                } else if (i === currentIndex) {
                    stepClass += " orders-progress__step--current";
                } else {
                    stepClass += " orders-progress__step--future";
                }

                return (
                    <React.Fragment key={step.key}>
                        {i > 0 && (
                            <div
                                className={`orders-progress__line${
                                    !isCancelled && i <= currentIndex
                                        ? " orders-progress__line--filled"
                                        : ""
                                }`}
                            />
                        )}
                        <div className={stepClass} title={step.label}>
                            <div className="orders-progress__dot" />
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default OrderProgressBar;
